// 财务信息
<template>
    <div class="main">
        <el-row :gutter="10" class="mar_tb">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="icon iconfont icon-danju-xiugai-tianchong" style="margin-right:2px;"></i>
                        <span style="font-size:13px;">财务信息</span>
                    </div>
                    <div class="search-content mar_b" style="margin-bottom:-15px;">
                        <el-form :inline="true" label-width="180px" size="mini" 
                            :model="query" class="demo-form-inline" ref="query">
                            <el-form-item prop="orders_no" label="订单号：" label-width="80px">
                                <el-input v-model="query.orders_no" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="saler" label="业务员：" label-width="80px">
                                <el-input v-model="query.saler" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="account_date" label="完成日期：" label-width="90px">
                                <el-date-picker v-model="query.account_date" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <!--
                            <el-form-item prop="account_date" label="记账日期：" label-width="100px">
                                <el-date-picker v-model="query.account_date" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item><br>
                            <el-form-item prop="clients" label="客户名称：" label-width="100px">
                                <el-input v-model="query.clients" placeholder="请输入"></el-input>
                            </el-form-item>
                            -->
                            <el-form-item class="search-but" style="float:right;margin-right:150px">
                                <el-button type="primary" @click="selectList">查询</el-button>
                                <el-button @click="resetForm('query')">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <el-button type="primary" @click="selectCertno" size="small" :disabled="isAble">获取证书号</el-button>
                        <el-button type="warning" @click="dialogTableVisible11 = true" size="small" :disabled="isAble">退货</el-button>
                        <el-button type="primary" @click="dialogTableVisible3 = true" size="small" :disabled="isAble">批量修改</el-button>
                        <!--
                        <el-button type="primary" @click="exportSelect" :disabled="isAble" size="small">导出选中</el-button>
                        <el-button type="primary" @click="exportAll" size="small">导出全部</el-button>
                        -->
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <!--分页-->
                    <div class="block tar mar_t">
                        <div class="text e-info auto-table">
                            <span style='float:left;font-size:18px'> 已选：{{data_len}} </span>
                        </div>
                        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pager.page"
                                       :page-sizes="[50, 100, 200, 500, 1000]" :page-size="pager.rows"
                                       layout="total,sizes, prev, pager, next, jumper"
                                       :total="pager.total"></el-pagination>
                    </div>
                    <div class="text e-info auto-table">
                        <el-table :data="financialInfoList" stripe
                            height='600px'  @selection-change="selectionLineChangeHandle1"
                            ref="refTable" @row-click="toggleExpand" @expand-change="expandChange"
                            :header-cell-style="{background:'#eef1f6',color:'black',fontSize:'12px',padding:'0',margin:'0'}" 
                            :row-style="{height:'10px',color:'black',fontSize:'12px',padding:'0 0',margin:'0'}">
                            <el-table-column type="expand" min-width="2%">
                                <template slot-scope="scope">
                                    <el-table :data="orderInfoList" @selection-change="selectionLineChangeHandle">
                                        <el-table-column type="selection" width="45" align="center"></el-table-column>
                                        <el-table-column align="center" min-width="12%" prop="cert_no" label="证书号" show-overflow-tooltip></el-table-column>
                                        <el-table-column align="center" min-width="8%" prop="place" label="地点"></el-table-column>
                                        <el-table-column align="center" min-width="20%" prop="canshu" label="参数">
                                            <template slot-scope="scope">
                                                <span>{{ scope.row.ct }}ct</span>
                                                <span>{{ scope.row.shape }}</span>
                                                <span>{{ scope.row.col }}</span>
                                                <span>{{ scope.row.cla }}</span>
                                                <br>
                                                <span>{{ scope.row.cut }}</span>
                                                <span>{{ scope.row.pol }}</span>
                                                <span>{{ scope.row.sym }}</span>
                                                <span>{{ scope.row.fl }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--
                                        <el-table-column align="center" min-width="8%" prop="shape" label="形状"></el-table-column>
                                        <el-table-column align="center" min-width="8%" prop="ct" label="重量" sortable></el-table-column>
                                        <el-table-column align="center" min-width="6%" prop="col" label="颜色"></el-table-column>
                                        <el-table-column align="center" min-width="7%" prop="cla" label="净度"></el-table-column>
                                        <el-table-column align="center" min-width="6%" prop="cut" label="切工"></el-table-column>
                                        <el-table-column align="center" min-width="6%" prop="pol" label="抛光"></el-table-column>
                                        <el-table-column align="center" min-width="6%" prop="sym" label="对称"></el-table-column>
                                        <el-table-column align="center" min-width="6%" prop="fl" label="荧光"></el-table-column>
                                        -->
                                        <!--
                                        <el-table-column align="center" min-width="8%" prop="sale_rap" label="Rap"></el-table-column>
                                        <el-table-column align="center" min-width="11%" prop="orders_usd" label="USD"></el-table-column>
                                        <el-table-column align="center" min-width="11%" prop="price" label="RMB" sortable></el-table-column>
                                        <el-table-column align="center" min-width="10%" prop="back" label="退点" sortable></el-table-column>
                                        <el-table-column align="center" min-width="9%" prop="rate" label="汇率"></el-table-column>
                                        -->
                                        
                                        <el-table-column align="center" min-width="12%" prop="usd_cost" label="USD成本"></el-table-column>
                                        <el-table-column align="center" min-width="12%" prop="rmb_cost" label="RMB成本"></el-table-column>
                                        <el-table-column align="center" min-width="12%" prop="received" label="实收"></el-table-column>
                                        <el-table-column align="center" min-width="12%" prop="income" label="利润"></el-table-column>
                                        <el-table-column align="center" min-width="10%" prop="channel" label="渠道"></el-table-column>
                                        <!--
                                        <el-table-column align="center" min-width="12%" prop="clients" label="客户姓名"></el-table-column>
                                        <el-table-column align="center" min-width="12%" prop="received_usd" label="实收USD"></el-table-column>
                                        <el-table-column align="center" min-width="12%" prop="create_user" label="业务员"></el-table-column>-->
                                        <el-table-column align="center" min-width="12%" prop="order_date" label="下单日期"></el-table-column>
                                        <el-table-column align="center" min-width="12%" prop="pay_date" label="付款日期1"></el-table-column>
                                        <!--
                                        <el-table-column align="center" min-width="10%" prop="caozuo" label="操作">
                                            <template slot-scope="scope">
                                                <el-button type="primary" @click="selectOrderList(scope.row)" 
                                                size="mini">修改</el-button>
                                            </template>
                                        </el-table-column>
                                        -->
                                    </el-table>
                                </template>
                            </el-table-column>
                            <el-table-column type="selection" align="center" width="40"></el-table-column>
                            <el-table-column align="center" min-width="10%" prop="orders_no" label="订单号" show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="diamond_status" label="状态"></el-table-column>
                            <el-table-column align="center" min-width="10%" prop="account_date" label="完成日期"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="sale_price" label="应收"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="paid" label="实收"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="clients" label="客户名称"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="saler" label="业务员"></el-table-column>

                            <!--
                            <el-table-column align="center" min-width="8%" prop="income" label="利润"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="profit_rate" label="利润率"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="clients" label="客户名称"></el-table-column>
                            <el-table-column align="center" min-width="10%" prop="remark" label="备注"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="create_user" label="业务员"></el-table-column>
                            
                            <el-table-column align="center" min-width="10%" prop="caozuo" label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini"
                                        @click="selectSavaList(scope.row)" >修改</el-button>
                                </template>
                            </el-table-column>
                            -->
                        </el-table>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <div class="text e-info auto-table">
            <el-dialog title="批量退货" :visible.sync = "dialogTableVisible11"
                width="600px" center :close-on-click-modal="false">
                <span style="color: red; font-size: 18px;font-weight: bold;">是否确认进行批量退货！！！</span>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogTableVisible11 = false">取消</el-button>
                    <el-button type="primary" @click="rebackEndOrders">确认</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="订单详情" :visible.sync="stockIdDialogVisible" @close="closeStockIdDialog" 
                center :close-on-click-modal="false" width="1400px">
                <div class="text e-info auto-table">
                    <span>钻石数量：{{ diamond_num }}</span>
                    <el-table :data="orderInfoList" stripe  size="big"
                        ref="refTable" height='600px'
                        :header-cell-style="{background:'#eef1f6',color:'black',fontSize:'12px',padding:'0 0',margin:'0 0'}" 
                        :row-style="{height:'12px',color:'black',fontSize:'13px',padding:'0 0',margin:'0 0'}">
                        <el-table-column type="selection" width="45" align="center"></el-table-column>
                        <!--
                        <el-table-column align="center" min-width="8%" prop="image_link" label="图片" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div>
                                    <el-image fit="contain" style="height:20px" v-if="scope.row.image_link !== '' || !scope.row.vedio_link" lazy
                                        :src="scope.row.image_link" :preview-src-list="[scope.row.image_link]">
                                    </el-image>
                                    <div v-if="scope.row.vedio_link" @click="openVideoDialog(scope.row.vedio_link)" style="cursor:pointer">
                                        <i class="el-icon-video-camera" style="font-size: 20px; color: #409EFF;"></i>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" min-width="9%" prop="sale_status" label="钻石状态"></el-table-column>
                        <el-table-column align="center" min-width="8%" prop="remark" label="备注"></el-table-column>
                        <el-table-column align="center" min-width="6%" prop="place" label="地点"></el-table-column>
                        
                        <el-table-column align="center" min-width="14%" prop="orders_no" label="订单号" show-overflow-tooltip></el-table-column>
                        -->
                        <el-table-column align="center" min-width="12%" prop="cert_no" label="证书号" show-overflow-tooltip></el-table-column>
                        <el-table-column align="center" min-width="8%" prop="shape" label="形状"></el-table-column>
                        <el-table-column align="center" min-width="8%" prop="ct" label="重量" sortable></el-table-column>
                        <el-table-column align="center" min-width="6%" prop="col" label="颜色"></el-table-column>
                        <el-table-column align="center" min-width="7%" prop="cla" label="净度"></el-table-column>
                        <el-table-column align="center" min-width="6%" prop="cut" label="切工"></el-table-column>
                        <el-table-column align="center" min-width="6%" prop="pol" label="抛光"></el-table-column>
                        <el-table-column align="center" min-width="6%" prop="sym" label="对称"></el-table-column>
                        <el-table-column align="center" min-width="6%" prop="fl" label="荧光"></el-table-column>
                        <el-table-column align="center" min-width="6%" prop="year" label="年份"></el-table-column>
                        <el-table-column align="center" min-width="8%" prop="sale_rap" label="Rap"></el-table-column>
                        <el-table-column align="center" min-width="11%" prop="orders_usd" label="USD"></el-table-column>
                        <el-table-column align="center" min-width="11%" prop="price" label="RMB" sortable></el-table-column>
                        <el-table-column align="center" min-width="10%" prop="back" label="退点" sortable></el-table-column>
                        <el-table-column align="center" min-width="9%" prop="rate" label="汇率"></el-table-column>
                        <el-table-column align="center" min-width="12%" prop="clients" label="客户姓名"></el-table-column>
                        <el-table-column align="center" min-width="12%" prop="received" label="实收"></el-table-column>
                        <!--<el-table-column align="center" min-width="12%" prop="received_usd" label="实收USD"></el-table-column>-->
                        <el-table-column align="center" min-width="12%" prop="create_user" label="业务员"></el-table-column>
                        <el-table-column align="center" min-width="11%" prop="order_date" label="下单日期"></el-table-column>
                        <el-table-column align="center" min-width="11%" prop="pay_date" label="付款日期"></el-table-column>
                    </el-table>
                </div>
            </el-dialog>
        </div>
        
        <div class="text e-info auto-table">
            <el-dialog title="收款" :visible.sync = "dialogTableVisible3" @close="closeSava" 
                width="1410px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="100px" size="mini"
                        :model="shoukuanform" class="demo-form-inline" ref="shoukuanform">
                    <el-table height="400" ref="refTable1" :data="dataOnLineListSelections"
                        show-summary :summary-method ="getSummaries_sk"
                        :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                        <el-table-column align="center" width="150" prop="canshu" label="参数">
                            <template slot-scope="scope">
                                <span>{{ scope.row.ct }}ct</span>
                                <span>{{ scope.row.shape }}</span>
                                <span>{{ scope.row.col }}</span>
                                <span>{{ scope.row.cla }}</span>
                                <br>
                                <span>{{ scope.row.cut }}</span>
                                <span>{{ scope.row.pol }}</span>
                                <span>{{ scope.row.sym }}</span>
                                <span>{{ scope.row.fl }}</span>
                            </template>
                        </el-table-column>
                        <!--
                        <el-table-column align="center" width="80" prop="shape" label="形状"></el-table-column>
                        <el-table-column align="center" width="50" prop="ct" label="重量"></el-table-column>
                        <el-table-column align="center" width="50" prop="col" label="颜色"></el-table-column>
                        <el-table-column align="center" width="50" prop="cla" label="净度"></el-table-column>
                        <el-table-column align="center" width="50" prop="cut" label="切工"></el-table-column>
                        <el-table-column align="center" width="50" prop="pol" label="抛光"></el-table-column>
                        <el-table-column align="center" width="50" prop="sym" label="对称"></el-table-column>
                        <el-table-column align="center" width="50" prop="fl" label="荧光"></el-table-column>
                        -->
                        <el-table-column align="center" width="80" prop="sale_rap" label="rap"></el-table-column>
                        <el-table-column align="center" width="140" prop="cert_no" label="证书号"></el-table-column>
                        <el-table-column align="center" width="80" prop="channel" label="渠道">
                            <template slot-scope="scope">
                                <el-form-item prop="channel" label-width="60px" style="margin-top:10px">
                                    <el-input v-model="scope.row.channel"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="150" prop="deal_date" label="完成日期">
                            <template slot-scope="scope">
                                <el-form-item prop="deal_date" label-width="50px" style="margin-top:10px">
                                    <el-date-picker v-model="scope.row.deal_date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width:140px"></el-date-picker>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="80" prop="back" label="折扣">
                            <template slot-scope="scope">
                                <el-form-item prop="back" label-width="50px" style="margin-top:10px">
                                    <el-input v-model="scope.row.back" oninput="value=value.replace(/[^-0-9.]/g,'')" 
                                        @input="handleInput1(scope.$index,scope.row.back)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="80" prop="rate" label="汇率">
                            <template slot-scope="scope">
                                <el-form-item prop="rate" label-width="50px" style="margin-top:10px">
                                    <el-input v-model="scope.row.rate" oninput="value=value.replace(/[^-0-9.]/g,'')"
                                        @input="handleInput2(scope.$index,scope.row.rate)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" prop="rmb_cost" label="RMB成本">
                            <template slot-scope="scope">
                                <el-form-item prop="rmb_cost" label-width="60px" style="margin-top:10px">
                                    <el-input v-model="scope.row.rmb_cost" oninput="value=value.replace(/[^-0-9.]/g,'')"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" prop="price" label="RMB">
                            <template slot-scope="scope">
                                <el-form-item prop="price" label-width="60px" style="margin-top:10px">
                                    <el-input v-model="scope.row.price" oninput="value=value.replace(/[^-0-9.]/g,'')"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" prop="received_r" label="实收RMB">
                            <template slot-scope="scope">
                                <el-form-item prop="received_r" label-width="60px" style="margin-top:10px">
                                    <el-input v-model="scope.row.received_r" oninput="value=value.replace(/[^-0-9.]/g,'')"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="80" prop="beilv" label="倍率">
                            <template slot-scope="scope">
                                <el-form-item prop="beilv" label-width="50px" style="margin-top:10px">
                                    <el-input v-model="scope.row.beilv" min="1" oninput="value=value.replace(/[^-0-9.]/g,'')" 
                                        @input="handleInput3(scope.$index,scope.row.beilv)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" prop="orders_usd" label="USD">
                            <template slot-scope="scope">
                                <el-form-item prop="orders_usd" label-width="60px" style="margin-top:10px">
                                    <el-input v-model="scope.row.orders_usd" oninput="value=value.replace(/[^-0-9.]/g,'')"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" prop="received_usd_r" label="实收USD">
                            <template slot-scope="scope">
                                <el-form-item prop="received_usd_r" label-width="60px" style="margin-top:10px">
                                    <el-input v-model="scope.row.received_usd_r" oninput="value=value.replace(/[^-0-9.]/g,'')"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams3">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import util from '../../common/js/util.js';
    export default {
        data() {
            return {
                isAble: true,
                placeList: [{'value':'全部'},{'value':'HK'},{'value':'CHINA'},{'value':'SZ'}
                            ,{'value':'INDIA'},{'value':'LAB'},{'value':'SH'},{'value':'H-K'}],
                isq: '',
                inv_status: '',
                addDataForm: {},
                addDataForm3: {},
                dataOnLineListSelections: [],
                dialogTableVisible3: false,
                dialogTableVisible11: false,
                dialogTableVisible10: false,
                shoukuanform: {},
                certnoList: [],
                idStr: '',
                certnoStr: '',
                financialInfoList: [],
                financialInfoAllList: [],
                data_len: 0,
                sale_rap_total: 0,
                sale_usd_total: 0,
                sale_price_total: 0,
                // 查询
                query: {
                    data_dt: [],
                    ct1: '',
                    ct2: '',
                    danhao: '1',
                    huiyuan: '1'
                },
                queryDate: '',
                // queryDate: this.getNowTime(),
                // 分页
                pager: {
                    page: 1,
                    rows: 50,
                    total: 0
                },
                stockIdDialogVisible: false,
                stockIdForm: {},
                orderInfoList:[],
                diamond_num: 0,
                rules: {},
                expandedRow: false
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                this.selectList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                this.selectList();
            },
            
            // 选择器选择数据，加工数据证书号
            selectionLineChangeHandle1(val) {
                /*
                // 统计选中数量
                this.data_len = val.length;
                // 选中导出数据赋值
                this.dataOnLineListSelections = val;
                // id、数据证书号拼接
                this.idList = val.map((item) => item.id);
                //数据选中后，显示按钮
                if(val.length>0) {
                    this.isAble = false;
                }else{
                    this.isAble = true;
                */
            },

            // 选择器选择数据，加工数据证书号
            selectionLineChangeHandle(val) {
                // 统计选中数量
                this.data_len = val.length;
                // 选中导出数据赋值
                this.dataOnLineListSelections = val;
                //this.dataOnLineListSelections.forEach(item =>{this.$set(item,'sale_price_r',Math.round(item.price))})
                this.dataOnLineListSelections.forEach(item =>{this.$set(item,'received_r',Math.round(item.received))})
                //this.dataOnLineListSelections.forEach(item =>{this.$set(item,'sale_usd_r',Math.round(item.orders_usd))})
                this.dataOnLineListSelections.forEach(item =>{this.$set(item,'received_usd_r',Math.round(item.received_usd))})
                // id、数据证书号拼接
                this.idList = val.map((item) => item.id);
                this.certnoList = val.map((item) => item.cert_no + '\n');
                //数据选中后，显示按钮
                if(val.length>0) {
                    this.isAble = false;
                }else{
                    this.isAble = true;
                }
            },
            // 获取证书号
            selectCertno() {
                this.certnoStr = this.certnoList.join(',');
                this.certnoStr = this.certnoStr.replaceAll(',','');
                // this.dialogTableVisible = true;
                // 复制
                this.copyText(this.certnoStr);
            },
            copyText(val){
                // 存储传递过来的数据
                //let userId = sessionStorage.getItem("userId");
                // createElement() 方法通过指定名称创建一个元素
                let newInput = document.createElement('textarea');
                // 讲存储的数据赋值给input的value值
                newInput.value = val;
                // appendChild() 方法向节点添加最后一个子节点
                document.body.appendChild(newInput);
                // select() 方法用于选择该元素中的文本
                newInput.select();
                // execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
                document.execCommand('Copy');
                // 清空输入框
                newInput.remove();
                // 下面是element的弹窗 不需要的自行删除就好
                this.$message({
                    message: "复制成功",
                    type: "success",
                });
            },
            // 修改数据状态 收款
            savaDataParams3() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                _this.certnoStr = _this.certnoList.join(',');

                var dataCopyStr = '';
                var forlist = this.dataOnLineListSelections;
                for (var i = 0; i < forlist.length; i++){
                    if(forlist[i].received_r===null || forlist[i].received_r===''){
                        _this.errorMsg('实收金额不能为空！');
                        return;
                    }

                    var dataCopy = forlist[i].id
                                +','+forlist[i].cert_no
                                +','+forlist[i].back
                                +','+forlist[i].rate
                                +','+forlist[i].price
                                +','+forlist[i].orders_usd
                                +','+forlist[i].received_r
                                +','+forlist[i].received_usd_r
                                +','+forlist[i].status
                                +','+forlist[i].orders_no
                                +','+forlist[i].channel
                                +','+forlist[i].beilv
                                +','+forlist[i].rmb_cost
                                +','+forlist[i].deal_date
                                +';'
                    dataCopyStr = dataCopyStr + dataCopy
                }

                util.publicget('/order/savaOrdersFinancialInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    id: _this.idStr,
                    certnoStr: _this.certnoStr,
                    dataCopyStr: dataCopyStr
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible3 = false;
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 删除数据
            savaDataParams5() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                util.publicget('/order/deleteOrdersInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    id: _this.idStr
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible8 = false;
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 修改订单退点
            handleInput1(row, val) {
                console.log(row);
                console.log(val);
                // 销售美金 = 销售rap * (1+新折扣%) *重量
                // 销售价格 = 销售美金 * 销售汇率
                let sale_rap = this.dataOnLineListSelections[row].sale_rap;
                let sale_rate = this.dataOnLineListSelections[row].rate;
                let ct = this.dataOnLineListSelections[row].ct;
                let orders_usd = (sale_rap * (1 + (val / 100)) * ct).toFixed(2);
                let sale_price =  Math.round((sale_rate * sale_rap * (1 + (val / 100)) * ct).toFixed(2));
                // 收款
                this.$set(this.dataOnLineListSelections[row], 'price', sale_price);
                this.$set(this.dataOnLineListSelections[row], 'orders_usd', orders_usd);
                this.$set(this.dataOnLineListSelections[row], 'received_r', sale_price);
                this.$set(this.dataOnLineListSelections[row],'received_usd_r',orders_usd)
                /*
                if(this.dataOnLineListSelections[row].place === 'HK' || this.dataOnLineListSelections[row].place === 'H-K'){
                    this.$set(this.dataOnLineListSelections[row], 'received_r', orders_usd);
                }
                */
            },
            // 修改订单汇率
            handleInput2(row, val) {
                console.log(row);
                console.log(val);
                // 销售美金 = 销售rap * (1+新折扣%) *重量
                // 销售价格 = 销售美金 * 销售汇率
                // let orders_usd = this.dataOnLineListSelections[row].orders_usd;
                let sale_rap = this.dataOnLineListSelections[row].sale_rap;
                let new_dis = this.dataOnLineListSelections[row].back;
                let ct = this.dataOnLineListSelections[row].ct;
                let orders_usd = (sale_rap * (1+(new_dis / 100)) * ct).toFixed(2);
                let sale_price = Math.round((val * orders_usd).toFixed(2));
                // 收款
                this.$set(this.dataOnLineListSelections[row], 'price', sale_price);
                this.$set(this.dataOnLineListSelections[row], 'orders_usd', orders_usd);
                this.$set(this.dataOnLineListSelections[row], 'received_r', sale_price);
                this.$set(this.dataOnLineListSelections[row], 'rate', val);
                this.$set(this.dataOnLineListSelections[row],'received_usd_r',orders_usd);
                /*
                if(this.dataOnLineListSelections[row].place === 'HK' || this.dataOnLineListSelections[row].place === 'H-K'){
                    this.$set(this.dataOnLineListSelections[row], 'received_r', orders_usd);
                }
                */
            },
            // 修改 倍率
            handleInput3(row,val) {
                console.log(val)
                let sale_rap = this.dataOnLineListSelections[row].sale_rap
                let sale_rate = this.dataOnLineListSelections[row].rate
                let orders_usd = this.dataOnLineListSelections[row].orders_usd
                //let new_dis = this.dataOnLineListSelections[row].back
                let ct = this.dataOnLineListSelections[row].ct
                if(!val){
                    val = 1
                }
                // USD
                // let sale_usd = (sale_rap*(1+(new_dis/100)) * ct).toFixed(2)
                // 实收USD 美金 * 倍率 就是折扣
                let yh_usd = (orders_usd * val).toFixed(2)
                // 反算折扣
                let dis = ((yh_usd / ct / sale_rap - 1) * 100).toFixed(2)
                // 实收rmb
                let sale_price =  Math.round((sale_rate * yh_usd).toFixed(2));
                // 实收rmb
                this.$set(this.dataOnLineListSelections[row], 'received_r', sale_price);
                this.$set(this.dataOnLineListSelections[row],'back',dis)
                this.$set(this.dataOnLineListSelections[row],'received_usd_r',yh_usd)
                this.$set(this.dataOnLineListSelections[row],'beilv',value)
                // 钻石报价的美金价
                //this.$set(this.dataOnLineListSelections[row],'sale_usd_r',Math.round(sale_usd))
                /*
                if(this.dataOnLineListSelections[row].place === 'HK' || this.dataOnLineListSelections[row].place === 'H-K'){
                    this.$set(this.dataOnLineListSelections[row], 'received_r', yh_usd);
                }
                */
            },
            // 修改订单数据
            savaDataParams() {
                let _this = this;
                // 判断表单是否通过了表单验证
                this.$refs.addDataForm.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/order/savaOrdersInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            stock_id: _this.addDataForm.stock_id,
                            cert_no: _this.addDataForm.cert_no,
                            id: _this.addDataForm.id,

                            rate: _this.addDataForm.rate,
                            back: _this.addDataForm.back,
                            status: _this.addDataForm.status,
                            received_type: _this.addDataForm.received_type,
                            price: _this.addDataForm.price,
                            received: _this.addDataForm.received,
                            remark: _this.addDataForm.remark
                        }, function (res) {
                            if (res.flag) {
                                _this.successMsg('本次操作成功！');
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        });
                    } else { // 否则返回
                        return false;
                    }
                });
            },
            // 前端处理 导出选中数据
            exportSelect() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['证书号','客户名称','货品状态', '记账日期', '到账日期'
                            , '成本rap', '成本折扣', '货品成本', '综合费点', '美金成本', '人民币成本'
                            , '销售美金', '销售汇率', '售价', '实收', '利润', '应收利润率'
                            , '备注', '业务员', '数据日期']
                    const filterVal = ['cert_no','clients','diamond_status', 'account_date', 'arrived_date'
                            ,'cost_rap', 'cost_dis', 'cost', 'point', 'usd_cost', 'rmb_cost'
                            , 'sale_usd', 'sale_rate', 'sale_price', 'paid', 'income', 'profit_rate'
                            , 'remark' , 'create_user', 'data_date' ]
                    const list = this.dataOnLineListSelections
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '财务信息')
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            // 导出全部数据
            exportAll() {
                this.selectAllList();
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['证书号','客户名称','货品状态', '记账日期', '到账日期'
                            , '成本rap', '成本折扣', '货品成本', '综合费点', '美金成本', '人民币成本'
                            , '销售美金', '销售汇率', '售价', '实收', '利润', '应收利润率'
                            , '备注', '业务员', '数据日期']
                    const filterVal = ['cert_no','clients','diamond_status', 'account_date', 'arrived_date'
                            ,'cost_rap', 'cost_dis', 'cost', 'point', 'usd_cost', 'rmb_cost'
                            , 'sale_usd', 'sale_rate', 'sale_price', 'paid', 'income', 'profit_rate'
                            , 'remark' , 'create_user', 'data_date' ]
                    const list = this.financialInfoAllList
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '全部财务信息')
                })
            },
            // 加载信息分页列表
            selectList() {
                let _this = this;
                util.publicget('/financial/queryFinancialInfoListPageModel', {
                    // cert_no: '203652.36',
                    orders_no: _this.query.orders_no,
                    equalsClients: _this.query.clients,
                    equalsSaler: _this.query.saler,
                    equalsDiamond_status: '已完成',
                    greaterEqualsAccount_date: _this.query.account_date == null ? '' : _this.query.account_date[0],
                    lessEqualsAccount_date: _this.query.account_date == null ? '' : _this.query.account_date[1],
                    greaterEqualsArrived_date: _this.query.arrived_date == null ? '' : _this.query.arrived_date[0],
                    lessEqualsArrived_date: _this.query.arrived_date == null ? '' : _this.query.arrived_date[1],
                    pageNo: _this.pager.page,
                    pageSize: _this.pager.rows
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.pager.total = res.count || 0;
                        _this.financialInfoList = res.obj;  
                    } else {
                        _this.errorMsg('本次操作失败');
                    }
                });
            },
            selectOrderList(row) {
                let _this = this;
                util.publicget('/order/queryOrdersAndJXCList', {
                    equalsCert_no: row.cert_no,
                    equalsStatus: '已完成'
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.addDataForm = res.obj[0];
                            _this.dialogTableVisible10 = true;
                        }else {
                            _this.showMsg("该证书号数据不存在");
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 加载查询订单单条记录
            selectSavaList(rows) {
                let _this = this;
                util.publicget('/financial/queryFinancialList', {
                    equalsId: rows.id,
                    equalsCert_no: rows.cert_no
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.addDataForm = res.obj[0];
                            _this.dialogTableVisible10 = true;
                        }else {
                            _this.showMsg("该证书号数据不存在");
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 加载查询订单全部记录
            selectAllList(rows) {
                let _this = this;
                util.publicget('/financial/queryFinancialList', {}, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        _this.financialInfoAllList = res.obj;
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 展开行显示数据
            expandChange(row) {
                let _this = this;
                //_this.stockIdForm = { ...row };
                //_this.stockIdDialogVisible = true;
                util.publicget('/order/queryOrdersAndJXCList', {
                    equalsOrders_no: row.orders_no,
                    equalsStatus: '已完成'
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.orderInfoList = res.obj;
                            //_this.diamond_num = res.obj.length;
                        }else{
                            _this.orderInfoList = [];
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 双击展开行
            toggleExpand(row) {
                /*
                if (this.expandedRow) {
                    // 如果之前有行处于展开状态，‌先收起它
                    this.$refs.refTable.toggleRowExpansion(this.expandedRow);
                }*/
                // 展开点击的行
                this.$refs.refTable.toggleRowExpansion(row);
                
                // 更新当前展开的行数据为点击的行数据
                //this.expandedRow = row;
            },
            closeStockIdDialog() {
                this.stockIdDialogVisible = false;
                //this.stockIdForm = {};
                this.orderInfoList = {};
            },
            // 已完成货品，或者其他收钱的需要退货
            rebackEndOrders(){
                let _this = this;
                let idStr = _this.idList.join(',');
                let cert_noStr = _this.certnoList.join(',').replaceAll('\n','');
                util.publicget('/order/rebackEndOrders', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    idStr: idStr,
                    cert_noStr: cert_noStr
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible11 = false;
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 计算汇总求和
            getSummaries_sk(param) {
                // param 是固定的对象，里面包含 columns与 data参数的对象 {columns: Array[4], data: Array[5]},包含了表格的所有的列与数据信息
                const { columns, data } = param;
                // console.log(param);
                // console.log(data)
                const sums = [];
                columns.forEach((column, index) => {
                    // console.log(column)
                    // console.log(index)
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    if (index === 7) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            //sums[index] = sums[index].toFixed(2);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 8) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 9) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            //sums[index] = sums[index].toFixed(2);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 11) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 12) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    /*
                    if (index === 15) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    */
                });
                return sums;
            },
            closeSava() {
                this.addDataForm = {};
                this.dialogTableVisible10 = false;
                this.selectList();
            },
            // 取消
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.query = {};
            },
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.start_date), 'yyyy-MM-dd');
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            }
        },
        mounted() {
            this.selectList();
        }
    };
</script>

<style lang="scss">
    /*
    ::v-deep .el-table__expand-icon {
        display: none !important;
    }*/
    .el-dialog .el-dialog__body{
        flex: 1;
        overflow: auto;
    }
     /*:header-cell-style="{background:'#eee8aa'}"
    .el-table--border:after,
    .el-table--group:after,
    .el-table:before{
        background-color: #eee8aa
    }

    .el-table--border,
    .el-table--group{
        border-color: #eee8aa
    }

    .el-table td,
    .el-table th.is-leaf{
        border-bottom: #eee8aa
    }

    .el-table--border th,
    .el-table--border th.gutter:last-of-type{
        border-bottom: #eee8aa
    }

    .el-table--border td,
    .el-table--border th{
        border-right: #eee8aa
    }
    */
</style>



// WEBPACK FOOTER //
// src/pages/financial/financialManageList.vue